export default "__VITE_ASSET__06068843__"